module.exports = __webpack_public_path__ + "img/sceneca_3.02f3fc47.png";